export function mergeRefs(...refs) {
    return (value) => {
        refs.filter((ref) => ref !== null).forEach((ref) => {
            if (typeof ref === "function") {
                ref(value);
            }
            else {
                //this is okay, see: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31065
                //usually a ref that you pass to a component should be readonly *to you* as the component should be in charge of updating it
                //but in this case we're hijacking a ref *before* it gets to any components so we can update it alongside a bunch of other stuff
                // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible. please refactor when possible.
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ref.current = value;
            }
        });
    };
}
